import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ZendeskGuideColor.svg",
  "use": "ZendeskGuideColor.svg-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ZendeskGuideColor.svg\">\n<path d=\"M22.0048 10L28.5 16.5H15.5L22.0048 10Z\" fill=\"#02363D\" />\n<path d=\"M22 19L37 34H7L22 19Z\" fill=\"#EB4962\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol